module.exports = require("/app/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 339
// module chunks = 231608221292675